import { useCallback } from 'react';

import { MY_DAY_CONFIRMATION_KEY } from '../../../../common/constants';
import CONFIRM_MY_DAY_STEP from '../../../../common/graphql/serviceRun/CONFIRM_MY_DAY_STEP';
import { useOfflineMutation } from '../../../offline';

/**
 * "Brief read" for one run, saved as the briefRead My day step when the driver
 * closes the brief (queued offline, no toast) so managers see it in the day
 * preview. driverDaySteps shows a brief that needs no acknowledgement as done
 * once read. Training sessions record nothing. Returns { markRead() }.
 */
const useBriefRead = (serviceRun, isTraining) => {
	const [confirmMyDayStep] = useOfflineMutation(CONFIRM_MY_DAY_STEP, { configKey: 'confirmMyDayStep' });
	const isRead = (serviceRun?.myDayConfirmations || [])
		.some(confirmation => confirmation?.key === MY_DAY_CONFIRMATION_KEY.BRIEF_READ);

	const markRead = useCallback(() => {
		if (!serviceRun?.id || !serviceRun?.brief || isRead || isTraining) {
			return;
		}

		// A lost read mark must never interrupt the driver.
		confirmMyDayStep({ variables: { id: serviceRun.id, stepKey: MY_DAY_CONFIRMATION_KEY.BRIEF_READ } })
			.catch(() => {});
	}, [confirmMyDayStep, isRead, isTraining, serviceRun?.brief, serviceRun?.id]);

	return { markRead };
};

export default useBriefRead;
